// extracted by mini-css-extract-plugin
module.exports = {"navIconWrap":"styles_navIconWrap__pNpf5","icon":"styles_icon__c3xIu","navWrap":"styles_navWrap__PFZKZ","navbarTitle":"styles_navbarTitle__zsRKn"};